import { data } from "./data"
import { TypedAccessor } from "./types"
import { TableCellWidth } from "../TableCell"
import { DataColumn } from "../useTable/types"

type EmailAccessorFn<T> = TypedAccessor<T, string | undefined>
type EmailColumn<T> = Omit<DataColumn<T>, "type" | "renderCell" | "width">
export type EmailColumnHelper<T> = (
  accessorFn: EmailAccessorFn<T>,
  col: EmailColumn<T>
) => DataColumn<T>

export function email<T>(
  accessorFn: EmailAccessorFn<T>,
  col: EmailColumn<T>
): DataColumn<T> {
  return data({
    renderCell: accessorFn,
    width: TableCellWidth.ExtraExtraLarge,
    ...col,
  })
}
